import { FeedCardSkeleton } from "src/components/feed-card/skeleton/feed-card-skeleton";

const LOADING_SKELETON_COUNT = 2;

export const FeedLoadingState = () =>
    Array.from({ length: LOADING_SKELETON_COUNT }).map((_, index) => <FeedCardSkeleton key={`skeleton-${index}`} />);
